<!--  -->
<template>
  <div style="z-index: 2">
    <h1 v-if="!registSuccess">欢迎注册LIGHT云</h1>
    <div class="registBox" v-if="!registSuccess">
      <img src="~@/assets/login/welcome.png" />
      <div :class="['form', { 'form-active': imageCodeShow }]">
        <h-form ref="form" :model="formData" :rules="formRules" inline cols="1">
          <h-form-item prop="phone" id="phone">
            <span class="pre-phone">+86</span>
            <h-input
              type="text"
              v-model="formData.phone"
              class="phone-input"
              placeholder="请输入您的手机号"
              style="width: 255px; margin-left: -4px"
              autocomplete="off"
            ></h-input>
            <p id="phoneRegisted" v-show="isRegisted">
              当前手机号已注册LIGHT云，建议您
              <a href="javascript:void(0);" @click="goLogin">立即登录></a>
            </p>
          </h-form-item>
          <h-form-item v-if="imageCodeShow">
            <h-input
              class="regist-input"
              v-model="formData.captcha_img_code"
              placeholder="请输入图形验证码"
            ></h-input>
            <img
              class="image-code"
              :src="imageCode.captcha_img_base64"
              @click="getCheckCode"
            />
          </h-form-item>
          <h-form-item prop="captcha_sms_code">
            <h-input
              type="text"
              v-model="formData.captcha_sms_code"
              placeholder="请输入短信验证码"
              style="width: 200px"
              autocomplete="off"
            ></h-input>
            <h-button
              @click="getSmsCheckCode"
              class="get-check-code"
              :class="{
                'check-code-active':
                  checkCodeActive && !resendShow && formData.phone
              }"
              >{{ !resendShow ? "获取短信验证码" : `${seconds}s` }}</h-button
            >
          </h-form-item>
          <h-form-item prop="login_password" id="psdRef">
            <h-input
              v-show="!passwordSee"
              type="password"
              v-model="formData.login_password"
              placeholder="请设置您的密码"
              autocomplete="new-password"
            ></h-input>
            <h-input
              v-show="passwordSee"
              v-model="formData.login_password"
              placeholder="请设置您的密码"
              autocomplete="new-password"
            ></h-input>
            <a>
              <img
                v-show="!passwordSee"
                class="see-open"
                @click="passwordSee = true"
                src="~@/assets/login/eyeOpen.png"
              />
            </a>
            <a>
              <img
                v-show="passwordSee"
                class="see-close"
                @click="passwordSee = false"
                src="~@/assets/login/eyeClose.png"
              />
            </a>
            <div class="psd-strong" v-show="psdStrongPopShow">
              <p>密码强度</p>
              <ul>
                <li
                  :class="{
                    'low-active': strong === 1 || strong === 2 || strong === 3
                  }"
                ></li>
                <li
                  :class="{ 'middle-active': strong === 2 || strong === 3 }"
                ></li>
                <li :class="{ 'hight-active': strong === 3 }"></li>
              </ul>
              长度为8-20字符，包含数字、大 <br />小写字母，建议添加特殊符号，
              <br />会显著提高密码安全性
            </div>
          </h-form-item>
          <h-form-item prop="login_password_confirm">
            <h-input
              v-show="!passwordConfirmSee"
              type="password"
              class="login-input"
              v-model="formData.login_password_confirm"
              placeholder="请在此输入密码"
            ></h-input>
            <h-input
              v-show="passwordConfirmSee"
              class="login-input"
              v-model="formData.login_password_confirm"
              placeholder="请在此输入密码"
            ></h-input>
            <img
              v-show="!passwordConfirmSee"
              class="see-open"
              @click="passwordConfirmSee = true"
              src="~@/assets/login/eyeOpen.png"
            />
            <img
              v-show="passwordConfirmSee"
              class="see-close"
              @click="passwordConfirmSee = false"
              src="~@/assets/login/eyeClose.png"
            />
          </h-form-item>
          <h-form-item style="margin-top: 20px" class="check-rule">
            <h-checkbox v-model="checkRule"></h-checkbox>
            <span class="agreement">
              我已阅读并同意
              <a
                href="https://www.hs.net/openplat-doc/gtnDoc?docId=ab23ca170f23445aa111319064068684"
                target="_blank"
                >《用户注册协议》</a
              >和
              <a
                href="https://www.hs.net/openplat-doc/gtnDoc?docId=21366e229a964fa7bf943b1f39229960"
                target="_blank"
                >《隐私政策声明》</a
              >
            </span>
          </h-form-item>
          <h-form-item>
            <h-button
              type="primary"
              @click="agreeAndRegist"
              class="right-butt agree-regist"
              style="width: 100%; height: 40px"
              :class="{ 'agree-regist-active': agreeActiveFlag }"
              >同意协议并注册</h-button
            >
          </h-form-item>
        </h-form>
      </div>
    </div>
    <!-- 完成注册 -->
    <!-- <div v-else class="regist-success-view">
      <img src="~@/assets/login/registSuccess.png" />
      <p>注册成功，欢迎加入LIGHT云</p>
      <div class="butt-cont">
        <h-button type="primary" @click="toUrl('/')" class="gray-butt"
          >返回首页</h-button
        >
        <h-button
          type="primary"
          @click="toUrl('/cloud/open/user/personalCertificaton.html')"
          class="right-butt"
          style="width: 90px; margin-right: 10px"
          >实名认证</h-button
        >
        <h-button
          type="primary"
          @click="toUrl('/cloud/open/user/companyCertificaton.html')"
          class="right-butt"
          style="width: 90px"
          >企业认证</h-button
        >
      </div>
    </div>-->
    <!-- 注册失败对话框 -->
    <h-msg-box
      v-model="registErrorShow"
      :mask-closable="false"
      width="400"
      :canDrag="false"
      class="regist-error-pop"
      :footerHide="true"
      title="提示"
    >
      <div class="regist-error-pop-cont">
        <img src="~@/assets/login/registFail.png" />
        <p>{{ registFailMsg }}</p>
        <h-button
          type="primary"
          @click="registErrorShow = false"
          class="right-butt"
          >确定</h-button
        >
      </div>
    </h-msg-box>
  </div>
</template>

<script>
import { isRegister, smsCheckCode, CheckCode, register } from "@/api/login.js";
import { queryParams, getUrlParam } from "@/utils";
import trackMixin from "@/components/mixins/track.js";
export default {
  data() {
    //验证手机号
    const phoneRule = (rule, value, callback) => {
      if (value) {
        if (!/^1[0-9]{10}$/.test(value)) {
          // 不合法
          this.checkCodeActive = false;
          // setTimeout(function () {
          //   $("#phone .h-select-dropdown").show()
          // }, 3)
          return callback(new Error("请输入正确的手机号码"));
        }
        this.checkExist(value);
      }
      return callback();
    };
    //验证短信验证码
    const checkCodeRule = (rule, value, callback) => {
      if (value) {
        if (value.length < 4) {
          return callback(new Error("最短不能少于4位字符"));
        }
      }
      return callback();
    };
    // 验证密码
    const psdRule = (rule, value, callback) => {
      if (rule.trigger === "blur") {
        this.psdStrongPopShow = false;
      } else {
        this.psdStrongPopShow = true;
      }
      if (value) {
        if (this.checkPerStrong(value) < 2) {
          return callback(new Error("密码过于简单"));
        }
        if (value.length < 8 || value.length > 20) {
          return callback(new Error("密码不符合要求"));
        }
      }
      return callback();
    };
    // 验证两次密码是否输入一致
    const confirmRule = (rule, value, callback) => {
      if (value) {
        if (this.formData.login_password !== value) {
          return callback(new Error("两次密码输入不一致"));
        }
      }
      return callback();
    };
    return {
      /**
       * checkCodeActive： 手机号是否合法
       * seconds： 60s倒计时
       * isRegisted: 是否注册过
       * resendShow：是否显示xx秒后可重发
       * imageCode：验证码对象
       * passwordSee: 是否显示密码
       * psdStrongPopShow: 是否显示密码强度
       * strong: 密码强度等级
       * checkRule: 是否同意协议选中框绑定值
       * agreeActiveFlag：是否同意协议
       * registSuccess: 是否注册成功
       * registErrorShow：是否注册失败
       * registFailMsg：注册失败消息提示
       * imageCodeShow: 是否显示图形验证码
       */
      checkCodeActive: false,
      formData: {},
      seconds: 60,
      isRegisted: false,
      resendShow: false,
      formRules: {
        phone: [{ validator: phoneRule, trigger: "change" }],
        captcha_sms_code: [{ validator: checkCodeRule, trigger: "change" }],
        login_password: [
          { validator: psdRule, trigger: "change" },
          { validator: psdRule, trigger: "blur" }
        ],
        login_password_confirm: [{ validator: confirmRule, trigger: "change" }]
      },
      imageCodeShow: false,
      imageCode: {},
      passwordSee: false,
      passwordConfirmSee: false,
      psdStrongPopShow: false,
      strong: 0,
      checkRule: false,
      agreeActiveFlag: false,
      registSuccess: false,
      registErrorShow: false,
      registFailMsg: "",
      registration_source: "", // 从其他去掉跳转过来时携带的渠道码【如：高校招聘为88】
      redirectUrlAfterRegister: "" // 注册后重定向的地址
    };
  },
  mixins: [trackMixin],
  methods: {
    goLogin() {
      this.handleTrack("PC_注册_登录引导");
      this.$router.push({ name: "登录" });
    },
    toUrl(url) {
      // var a = getUrlParam(window.location.href, "gtn_ticket")
      // console.log(url + "?gtn_ticket=" + a)
      // var url =
      //   url + "?gtn_ticket=" + getUrlParam(window.location.href, "gtn_ticket")
      window.location.href = url;
    },
    //注册
    agreeAndRegist() {
      this.handleTrack("PC_注册_注册按钮");
      var that = this;
      if (!that.agreeActiveFlag) {
        return;
      }
      if (
        !(
          that.formData.phone &&
          that.formData.phone !== "" &&
          that.formData.captcha_sms_code &&
          that.formData.captcha_sms_code !== "" &&
          that.formData.login_password &&
          that.formData.login_password !== "" &&
          that.formData.login_password_confirm &&
          that.formData.login_password_confirm !== ""
        ) ||
        (this.formData.captcha_img_code == "" && this.imageCodeShow)
      ) {
        that.$hMessage.error("请填写完整注册信息");
        return;
      }
      that.$refs["form"].validate(valid => {
        if (valid) {
          return new Promise(function(resolve, reject) {
            var registration_source = "";
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
              registration_source = "微信"; // 注册来源修改
            }
            let url = getUrlParam(window.location.href, "service");
            // url 为空，按原来逻辑，不为空，则调整url
            if (that.registration_source && that.redirectUrlAfterRegister) {
              // 如果是从高校跳转过来的，那么注册成功返回到处理过的url
              url = that.redirectUrlAfterRegister;
            }
            var params = {
              ...that.formData,
              success_redirect: url
                ? decodeURIComponent(url)
                : window.location.href + "/registerSuccess"
            };
            if (that.registration_source) {
              params.registration_source = that.registration_source;
            }
            // 2021年开发者大会来源代码
            const channel_source =
              sessionStorage.getItem("channel_source") || "";
            if (channel_source) params.channel_source = channel_source;
            register(params)
              .then(response => {
                if (response.error_code != "0") {
                  that.registFailMsg = response.error_info;
                  that.registErrorShow = true;
                  that.form = {};
                } else {
                  that.registSuccess = true;
                  let hsid = this.$store.getters.hsid||'-';
                  gdp("setUserId", hsid);
                  that.gioTrackEvent("OP_registerSuccess", {
                    hsUserId_var: hsid || "-",
                    registerAccount_var: that.formData.phone || "-",
                    registerChannel_var: 5525
                  });
                  that.$store.commit("SET_TOKEN", response.data.access_token);
                  // 注冊成功之後回去用户中心登录
                  window.location.href = response.data.success_redirect;
                  localStorage.setItem("isPhoton", response.data.is_pho);
                  localStorage.setItem(
                    "photon_num",
                    response.data.member_single_point_amount
                  );

                  resolve();
                }
              })
              .catch(err => {});
          });
        } else {
        }
      });
    },
    // 设置密码强度
    checkPerStrong(val) {
      var val = val.replace(/\s+/, "");
      var modes = 0;
      this.strong = 0;
      if (/\d/.test(val)) modes++; /* 有数字 */
      if (/[a-z]/.test(val)) modes++; /* 有小写 */
      if (/[A-Z]/.test(val)) modes++; /* 有大写 */
      if (modes === 3) {
        this.strong = 2;
      } else if (modes !== 0) {
        this.strong = 1;
      }
      if (/\W/.test(val)) modes++; /* 有特殊字符 */
      if (modes === 4) {
        this.strong = 3;
      }
      return this.strong;
    },
    //获取图形验证码
    getCheckCode() {
      CheckCode()
        .then(res => {
          this.imageCode = res;
          console.log(res, this.imageCode);
        })
        .catch(error => {});
    },
    // 验证手机号是否注册过
    checkExist(val) {
      var param = queryParams({ phone: this.formData.phone });
      isRegister(param)
        .then(response => {
          if (response.is_register == 1) {
            // 已注册
            this.isRegisted = true;
            this.checkCodeActive = false;
          } else {
            // 未注册
            this.isRegisted = false;
            this.checkCodeActive = true;
          }
        })
        .catch(err => {});
    },
    //获取短信验证码
    getSmsCheckCode() {
      this.handleTrack("PC_注册_获取验证码");
      var that = this;
      if (!that.checkCodeActive || that.formData.phone === "") {
        // 手机号码不合法
        return;
      }
      return new Promise(function(resolve, reject) {
        if (that.resendShow) {
          // 获取短信验证码次数超显示图形验证码
          console.log(33);
          resolve();
          return;
        } else {
          var params = { ...that.formData, captcha_sms_type: 3 };
          params = that.imageCodeShow
            ? {
                ...params,
                captcha_img_id: that.imageCode.captcha_img_id
              }
            : params;
          params = queryParams(params);
          smsCheckCode(params)
            .then(res => {
              if (res.error_code == "110004") {
                that.$hMessage.info(res.error_info);
                that.imageCodeShow = true;
                that.getCheckCode();
                resolve();
              } else if (res.error_code == "0") {
                that.tips = "";
                console.log();
                that.resendMessage();
                console.log(resendMessage);
              } else {
                that.getCheckCode();
                that.$hMessage.info(res.error_info);
              }
            })
            .catch(error => {});
        }
      });
    },
    // 60s后重新发送验证码
    resendMessage() {
      this.resendShow = true;
      let timer = null;
      this.seconds = 60;
      timer = setInterval(() => {
        if (this.seconds == 0) {
          this.resendShow = false;
          clearInterval(timer);
          return;
        }
        this.seconds--;
      }, 1000);
    }
  },
  watch: {
    checkRule: function(val) {
      var that = this;
      if (val) {
        that.agreeActiveFlag = true;
      } else {
        that.agreeActiveFlag = false;
      }
    }
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    // 获取注册来源字段以及注册成功后的回跳地址
    const url = decodeURIComponent(location.href).split("service=");
    if (url[url.length - 1].indexOf("registration_source") > -1) {
      // 如果该地址中有registration_source，则取出
      try {
        this.registration_source = getUrlParam(
          url[url.length - 1],
          "registration_source"
        );
        this.redirectUrlAfterRegister = decodeURIComponent(
          getUrlParam(window.location.href, "service")
        ).split("&registration_source")[0];
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
h1 {
  min-width: 171px;
  text-align: center;
  margin: 0 auto;
  padding-bottom: 30px;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #000000;
  //   margin-bottom: 3%;
}
.registBox {
  width: 840px;
  height: 470px;
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  background: #ffffff;
  justify-content: space-between;
  z-index: 2;
  img {
    width: 300px;
    height: 470px;
  }
  .form {
    width: 540px;
    height: 470px;
    padding: 60px 105px;
    .h-input-left {
      border-radius: 4px;
      height: 40px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #909399;
      letter-spacing: 0;
    }
    #phoneRegisted {
      color: #ff595e;
      position: absolute;
      top: 35px;
      left: 10px;
      font-size: 12px;
    }
    .get-check-code {
      background: #e2e2e2;
      border-radius: 4px;
      width: 110px;
      height: 40px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #909399;
      margin-left: 10px;
      float: right;
      padding: 0;
    }
    .check-code-active {
      background: #4b83ff;
      color: #fff;
      border: none;
    }
    .image-code {
      width: 104px;
      height: 40px;
      position: absolute;
      right: 0px;
      border: 1px solid #d9d9d9;
      border-radius: 0 6px 6px 0;
      cursor: pointer;
    }
    .see-open,
    .see-close {
      cursor: pointer;
      width: 20px;
      height: 12px;
      position: absolute;
      right: 10px;
      top: 15px;
      z-index: 5;
    }
    .psd-strong {
      width: 235px;
      height: 102px;
      background: #ffffff;
      border: 0 solid #cbcbcb;
      box-shadow: 0 0 10px 0 rgba(216, 216, 216, 0.8);
      border-radius: 4px 4px 4px 4px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #303133;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      padding: 10px 28px 16px 28px;
      position: absolute;
      left: 350px;
      top: 0px;
      line-height: 15px;
      &:before {
        position: absolute;
        content: "";
        width: 0;
        height: 0;
        right: 100%;
        top: 15px;
        border-top: 4px solid transparent;
        border-right: 8px solid #fff;
        border-bottom: 4px solid transparent;
      }
      ul {
        display: flex;
        flex-direction: row;
        li {
          width: 60px;
          height: 5px;
          border: none;
          background: #dcdfe6;
          &:nth-child(1) {
            border-radius: 2px;
          }
          &:nth-child(3) {
            border-radius: 2px;
          }
        }
        .low-active {
          background: #f56c6c;
        }
        .middle-active {
          background: #ffcf4f;
        }
        .hight-active {
          background: #26bc7e;
        }
      }
      p {
        color: #f56c6c;
      }
    }
  }
  .form-active {
    padding: 20px 105px;
  }
}
.regist-success-view {
  width: 840px;
  height: 470px;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  z-index: 5;
  img {
    width: 81px;
    height: 90px;
    margin: 99px 0 20px 0;
    display: inline-block;
  }
  p {
    font-family: PingFangSC-Regular;
    font-size: 15px;
    color: #303133;
    margin: 20px 0 66px 0;
    display: inline-block;
    position: inherit;
  }
}
.regist-error-pop {
  display: flex;
  flex-direction: row;
  align-items: center;
  .regist-error-pop-cont {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 81px;
      height: 90px;
      margin-bottom: 23px;
    }
    p {
      font-size: 12px;
      color: #ff595e;
      text-align: center;
      margin-bottom: 26px;
    }
    button {
      background: #4b83ff;
      border-radius: 2px;
      border-radius: 2px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      line-height: 12px;
    }
  }
}
</style>
<style lang="scss">
.right-butt {
  height: 32px;
  background: #4b83ff;
  border-radius: 4px;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ffffff;
  padding: 0px 8px;
  border: none;
}
.registBox {
  .form {
    width: 540px;
    height: 470px;
    padding: 60px 105px;
    .h-input-left {
      border-radius: 4px;
      height: 40px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #909399;
      letter-spacing: 0;
    }
    .form .phone-input .h-input-left {
      border-radius: 0 4px 4px 0;
    }
    .form .phone-inputnput {
      height: 40px;
    }
    .h-form-row .h-form-item {
      margin-bottom: 12px;
    }
    .regist-input {
      width: 320px;
      height: 46px;
      .h-input {
        width: 320px;
        height: 40px;
        padding: 4px 16px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #9b9b9b;
        border-radius: 6px;
      }
    }
    .pre-phone {
      background: #e2e2e2;
      border-radius: 4px 0 0 4px;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #909399;
      display: inline-block;
      width: 65px;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .check-rule .h-form-item-content {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      .agreement {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #909399;
        line-height: 20px;
        height: 40px;
        width: 296px;
        display: inline-block;
        margin: -4px 0 0 10px;
      }
    }
    .agree-regist {
      background: #e2e2e2;
      border: 1px solid #e2e2e2;
    }
    .agree-regist-active {
      background: #4b83ff;
      border: 1px solid #4b83ff;
    }
  }
}
.butt-cont {
  .gray-butt {
    background: transparent;
    border-radius: 2px;
    height: 32px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    border: none;
    margin-right: 10px;
    width: 90px;
    padding: 0px 8px;
    border: 1px solid #bfc4cd;
    color: #666666;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/components/regist.vue